export default "/images/vendor/flag-icon-css/flags/4x3/gt.svg?ccfc27d34052eec1eb6ecfa9805ae620";